import Constants from "expo-constants";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BackHandler, Linking, Platform, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";

/** Opens the platform store listing baked into app.config.js. */
function openStore(): void {
    const extra = Constants.expoConfig?.extra;
    const url =
        Platform.OS === "ios"
            ? `https://apps.apple.com/app/id${extra?.appStoreApplicationId}`
            : extra?.playStoreUrl;
    if (typeof url === "string" && url) {
        Linking.openURL(url);
    }
}

/** Full-screen gate. It cannot be dismissed. */
export function ForceUpdateScreen() {
    const { t } = useTranslation();
    const store =
        Platform.OS === "ios" ? t("forceUpdate.storeAppStore") : t("forceUpdate.storeGooglePlay");

    useEffect(() => {
        if (Platform.OS !== "android") {
            return;
        }
        const subscription = BackHandler.addEventListener(
            "hardwareBackPress",
            () => true,
        );
        return () => subscription.remove();
    }, []);

    return (
        <View className="flex-1 bg-background">
            <SafeAreaView className="flex-1 justify-center gap-6 px-6">
                <Text variant="h2" className="text-center">
                    {t("forceUpdate.title")}
                </Text>
                <Text className="text-center leading-6">
                    {t("forceUpdate.body", { store })}
                </Text>
                <Button className="w-full" onPress={openStore}>
                    <Text>{t("forceUpdate.update", { store })}</Text>
                </Button>
            </SafeAreaView>
        </View>
    );
}
